///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/product-categories.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ProductCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {
        public productCategories: ProductCategoriesCollection;
        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.productCategories;
        }

        get totalSelectedCount(): number {
            return this.productCategories.value.length;
        }


        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.productCategories = new ProductCategoriesCollection(this.model[properties[0]], [], {
                criteria: options.criteria
            });

            this.title = 'LABEL_PRODUCT_CATEGORIES';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCT_CATEGORIES';
            this.totalSelectedMessage = 'LABEL_TOTAL_PRODUCT_CATEGORIES_SELECTED'

            if (options.required) {
                this.validation.push(new RequiredValidation(this.productCategories, 'LABEL_PRODUCT_CATEGOIRIES_REQUIRED'));
            }
        }

        setWatchers(scope: angular.IScope) {
            this.productCategories.setWatchers(scope);
            super.setWatchers(scope);
        }

        onCriteriaUpdate(newCriteria: _.Dictionary<any>, $q: angular.IQService): angular.IPromise<any> {
            this.productCategories.updateCriteria(newCriteria);
            return this.productCategories.fetch();
        }
    }
}
